<template>
  <v-app class="whole">
    <v-img src="./shop.png" :height="400" ></v-img>
    <div class="inside">
    <div class="myform">
      <div class="title-spaced">
        <div class="text-center titleText">お買い上げありがとうございます。</div>
        <div class="text-center">この度は、K51インターナショナルの商品をご購入下さいまして<br>
          誠にありがとうございます。</div>
      </div>
      <div class="infoSpace">
        <div class="titleCompany">スーツのお手入れ方法</div>
        <div class="memoText">
          <p>日常的にスーツを着用していると、見えない微細なほこりがたまります。</p>

          <p>しかしながら、着用するたびにクリーニングに出すというのは不経済ですし、生地のダメージからしても現実的ではありません。</p>

          <p>かといって、見えない汚れをそのままにしておくこともまた、スーツのダメージを大きくします。</p>

          <p>それを防ぐためには、ブラッシングが最重要となります。</p>

          <p>着用後に毎回、最低でも３回に1回はブラシを使用してお手入れすることで、スーツの寿命を延ばすことができます。</p>

          <p>また、ブラッシングすることで、絡まったり毛羽立ったりした繊維の流れを整えられるのでスーツのテカりや毛玉を防ぐという効果もあるのです。</p>

          <p>加えて、ブラッシングする際にはスーツをしっかり見るので、思わぬ汚れやシミを発見しやすくなるというメリットもあります。</p>

          <p>このブラッシングによるお手入れを習慣づければ、汚れのダメージを減らし、毛玉ができにくくなり、さらにクリーニングの回数も減らせるので、スーツの寿命を長くすることができますよ。</p>

          <p>ただし、スーツが湿っている際には、必ず風通しの良いところで陰干しをしてから行うことが大切です。</p>
          <p>また、生地の縫い目に沿って上から下に向かって行うことに留意してください。</p>
        </div>


      </div>

      <div class="btnSet2">
        <v-btn color="indigo" text dark x-large  @click="back">
          <div class="btnText">トップページに戻る</div></v-btn>
      </div>


    </div>
    </div>
  </v-app>
</template>

<script>
import products from "./ECサイト商品リスト.json";
import { mapGetters } from "vuex"
  export default {
    data() {
      return {
        inputForm: {},      
        checkboxdata: [],
        item: '上記の内容と同じ',
        val: true,
        items: [],
        products,
      }
    },
    computed:{
      product() {
        const result = products.find((v) => v.id === Number(this.id))
        return result
      },
      ...mapGetters('cart', ['productsList','profile']),
      totalPrice() {
        let totalPrice = 0
        for(let item in this.productsList){
          
          let id = this.productsList[item]
          window.console.log('id: ', id)
          const result = products.find((v) => v.id === Number(id))
          this.items.push(result)

          totalPrice += result.price
        }

        return totalPrice
      },
    },
    mounted() {
     
    },
    filters: {
      toLocaleString(value) {
        return value.toLocaleString();
      },
    },
    methods: {
      back() {
        // this.$store.dispatch('cart/updateProfile', inputForm )
        this.$router.push({ name: 'top' })
      },
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 1%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 1%;
        }
      }
  .myform{
   background-color: white;
    width: 70%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 80%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 60%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
    margin: 0 0 15% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 7% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;

  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .tableSpace_sum {
    margin: 0 0 0 60%;
  }
  .infoSpace {
    margin: 7% 0;
  }
  .totalPrice {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .productPic {
    margin: 10% 0;
    /* padding: 10% 0; */
  }
  .memoText {
    margin: 2% 5% 5% 5% ;
  }
  .titleText {
    font-size: 1.8rem;
    font-weight: 600;
  }
</style>